import { flatMap } from 'rxjs/operators';
import { PaymentMeansRequest } from '~client/model/payment-means-request';
import { SpreedlyRequest } from '~client/model/spreedly-request';
import { SpreedlyResponse } from '~client/model/spreedly-response';
import { rxTask } from '~common/helper/mobx-tasks';
import { apiClient, spreedlyClient } from '~web/client';

export const createPaymentMethod = rxTask(
  (spreedlyRequest: SpreedlyRequest, paymentMeansRequest: PaymentMeansRequest) =>
    spreedlyClient.createPaymentMethod$(spreedlyRequest).pipe(
      flatMap((response: SpreedlyResponse) => {
        paymentMeansRequest.tokenId = response.transaction.payment_method.token;
        return apiClient.paymentController.createPaymentMethod$(paymentMeansRequest);
      }),
    ),
);



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/interactor/payment/create-payment-method.ts